/** Shared profit analysis window for Profit Agent tab ↔ ZOE delegation (Phase A8). */

export const PROFIT_AGENT_PERIOD_STORAGE_KEY = 'zecure_profit_agent_period_v1';

export type StoredProfitAgentPeriod = {
  date_from: string;
  date_to: string;
};

export function readStoredProfitAgentPeriod(): StoredProfitAgentPeriod | null {
  try {
    const raw = sessionStorage.getItem(PROFIT_AGENT_PERIOD_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredProfitAgentPeriod;
    if (!parsed?.date_from || !parsed?.date_to) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeStoredProfitAgentPeriod(period: StoredProfitAgentPeriod): void {
  try {
    sessionStorage.setItem(PROFIT_AGENT_PERIOD_STORAGE_KEY, JSON.stringify(period));
  } catch {
    // ignore
  }
}
